import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getListsUploadStatus } from '@global/api'

export const KEY = 'lists-upload-status'

interface IQuery extends Omit<UseQueryOptions<QueryResponse>, 'queryFn'> {
  listId: string
}

export enum uploadStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  PROCESSING = 'PROCESSING',
}

interface QueryResponse {
  status: uploadStatus
  error_type: 'ENCODING' | 'HEADERS MISMATCH' | 'DROPDOWN HEADER'
  error_message: string
  invalid_rows: string
}

export const useListUploadStatusQuery = ({ listId, ...options }: IQuery) =>
  useQuery({
    queryKey: [KEY, listId],
    queryFn: ({ signal }) =>
      getListsUploadStatus<QueryResponse>({
        listId,
        signal,
      }),
    cacheTime: 0,
    retry: false,
    ...options,
  })
